const screeningMeasures: any = [
    "Screened",
    "Alternative Screening",
    "Exemption"
];

const screeningCodes: any = {
  'X-RAY': 'XRY',
  'ETD': 'ETD',
  'PHYSICAL': 'PHS',
  'K9': 'EDD',
  '3PK9': 'EDD',
  'CCSF': '',
  'XRAY': 'XRY',
  'INNER ETD': 'ETD',
  'PHYSICAL SEARCH': 'PHS',
};

const alternativeScreeningOptions: Array<string> = [
  "Medical Shipments (18.3.6.1)",
  "Human Remains (18.3.6.2)",
  "Live Animals (18.3.6.3) ",
  "Hazmat (18.3.6.4)",
  "Federal Reserve (18.3.6.5)",
  "Dept Of Defence (18.3.6.3)",
  "US CBP Orders Of Export (18.3.6.7)",
  "US Law Enforcement (18.3.6.8)",
  "Diplomatic Pouches (17.2) "
];

const screenedOptions: Array<string> = [
  "X-Ray", "ETD", "Physical", "K9", "CCSF", "Received Screened from Interline"
];


const measureTypes: Array<string> = [
  'Screened',
  'Exemption',
  'Alternative Screening'
];

const exemptionsList: Array<string> = [
  "Items with 68kg or less",
  "Locked hard sided ULD container",
  "Banded in a skid on all four sides",
  "HAZMAT",
  "CCSF",
  "Items can only be opened from outside",
  "Human organs, human blood and by products",
  "Emergency life saving drugs drugs",
  "Human Remains",
  "Lower Deck Cargo",
  "Federal Reserve / US Treasury sealed",
  "Cargo that cannot have a person Inside",
  "Department of defence"
];

const alarmList: Array<string> = [
  "Inner ETD",
  "Physical Search",
  "Xray",
  "Return To Customer"
];

function getScreeningCode(scrName: string): string {
  return screeningCodes[scrName];
}

  export {
    screeningMeasures,
    alarmList,
    alternativeScreeningOptions,
    screenedOptions,
    exemptionsList,
    measureTypes,
    getScreeningCode
  }